import { bindActionCreators } from 'redux'
import VerifyEmail from '@piconetworks/verify-email'
import withInjection from '@piconetworks/with-injection'

import Account from 'common/modules/account'
import Loader from 'common/modules/loader'

const mapStateToProps = (state, props) => ({
    ...props,
    hasUserLoader: Loader.selectors.hasUserLoader(state),
    publisherName: Loader.selectors.publisherName(state),
    userEmail: Loader.selectors.userEmail(state),
    userVerified: Loader.selectors.userVerified(state),
    redirectUrl: state.zoid?.xprops?.content?.url,
})

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({
        requestLoginLink: Account.creators.requestLoginLink,
    }, dispatch),
    dispatch,
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { dispatch, requestLoginLink } = dispatchProps

    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        requestLoginLink: (params = {}) => {
            dispatch(requestLoginLink({
                ...params,
                redirectUrl: stateProps.redirectUrl,
            }))
        },
    }
}
const InjectedThanks = withInjection(VerifyEmail, {
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
})

export default InjectedThanks
